export default {
  text: 'Estamos a preparar a sua mesa 🍽…',
};
